export const catchQueryFilters = function (divider = '~') {
    const searchParams = new URLSearchParams(location.search);
    let new_filters = {};
    searchParams.forEach((value, key) => {
        let [type, index] = key.split(divider);
        if (!new_filters[index]) {
            new_filters[index] = {};
        }
        new_filters[index][type] = value;
    });

    return Object.keys(new_filters).map(index => new_filters[index]);
}
